module.exports = __webpack_public_path__ + "img/cuba.28c5aa5.webp";